import React from 'react';
import classNames from 'classnames';
import { CheckValue } from '../../../services/types/Misc';

interface Props {
  name?: string;
  className?: string;
  disabled?: boolean;
  radioValue: string;
  element: CheckValue;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormRadioButton = (props: Props) => {
  const { name, className, radioValue, disabled, element, handleChange } = props;

  const RadioButtonClass = classNames({
    'radio-btn': true,
    disabled,
  });

  const SelectedLabelClass = element.checked ? 'selected' : '';
  const radClass = className ? ` radio-btn--${className}` : '';

  return (
    <div className="form__form-group">
      <div className="form__form-group-field">
        <label className={`${RadioButtonClass}${radClass}`} htmlFor={element.htmlId}>
          <input
            id={element.htmlId}
            key={element.htmlId}
            type="radio"
            className="radio-btn__radio"
            name={name}
            value={radioValue}
            onChange={handleChange}
            checked={element.checked}
            disabled={disabled}
          />
          <span className="radio-btn__radio-custom" />
          <span className={`radio-btn__label ${SelectedLabelClass}`}>{element.text}</span>
        </label>
      </div>
    </div>
  );
};

export default FormRadioButton;
